import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "./api";
import { handleResponseStatus, updateIdField, updateItem } from "./utils";

const initialState = {
    items: [],
    fetchStatus: "success", // 'idle' | 'loading' | 'success' | 'failed'
    fetchByIdStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    createStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    updateStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    deleteStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    assignStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    pagination: {},
    error: null
};


// Get all branches that have subscription
export const fetchBranchSubscription = createAsyncThunk('globalSubscription/fetchBranchSubscription', async ({ page = 1, limit = 10 } = {}) => {
    try {
        const response = await api.get(`/sdg/branchsubscription?page=${page}&limit=${limit}`);
        return { ...response };
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

// Fetch Global Branch with subscription by ID
export const fetchBranchSubscriptionById = createAsyncThunk('globalSubscription/fetchBranchSubscriptionById', async (id) => {
    try {
        const response = await api.get(`/sdg/branchsubscription/${id}`);
        return { ...response };
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

// Assign Subscription to branch
export const assignBranchSubscription = createAsyncThunk('globalSubscription/assignBranchSubscription', async (data) => {
    try {
        const response = await api.post(`/sdg/branchsubscription`, data);
        return { ...response };
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

const branchSubscriptionSlice = createSlice({
    name: "globalProduct",
    initialState,
    reducers: {
        resetUpdateStatus(state) {
            state.updateStatus = 'idle';
        },
        resetDeleteStatus(state) {
            state.deleteStatus = 'idle';
        },
        resetCreateStatus(state) {
            state.createStatus = 'idle';
        },
        resetAssignStatus(state) {
            state.assignStatus = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch branch with subscription
            .addCase(fetchBranchSubscription.pending, (state) => {
                state.fetchStatus = 'loading';
            })
            .addCase(fetchBranchSubscription.fulfilled, (state, action) => {
                const { fetchStatus, error } = handleResponseStatus(action.payload, 'fetchStatus');
                const { data, ...pagination } = action.payload.data;
                state.items = fetchStatus === "success" ? updateIdField(data) : state.items;
                state.fetchStatus = fetchStatus;
                state.pagination = pagination;
                state.error = error;
            })
            .addCase(fetchBranchSubscription.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })

            // Fetch Global branch with subscription by ID
            .addCase(fetchBranchSubscriptionById.pending, (state) => {
                state.fetchByIdStatus = 'loading';
            })
            .addCase(fetchBranchSubscriptionById.fulfilled, (state, action) => {
                const { fetchByIdStatus, error } = handleResponseStatus(action.payload, 'fetchByIdStatus');
                state.items = fetchByIdStatus === "success" ? updateItem(action.payload.data.data, state.items) : state.items;
                state.fetchByIdStatus = fetchByIdStatus;
                state.error = error;
            })
            .addCase(fetchBranchSubscriptionById.rejected, (state, action) => {
                state.fetchByIdStatus = 'failed';
                state.error = action.error.message;
            })

            // Assign Subscription To Branch
            .addCase(assignBranchSubscription.pending, (state) => {
                state.assignStatus = 'loading';
            })
            .addCase(assignBranchSubscription.fulfilled, (state, action) => {
                const { assignStatus, error } = handleResponseStatus(action.payload, 'assignStatus');
                state.assignStatus = assignStatus;
                state.error = error;
            })
            .addCase(assignBranchSubscription.rejected, (state, action) => {
                state.assignStatus = 'failed';
                state.error = action.error.message;
            })
    }
});

export const { resetUpdateStatus, resetDeleteStatus, resetCreateStatus, resetAssignStatus } = branchSubscriptionSlice.actions;
export default branchSubscriptionSlice.reducer;
